module.exports = __webpack_public_path__ + "56c08b430f5eaba8a0f3f7f64ad345fd.png";